export default __webpack_public_path__ + "static/media/volvo.405170ca.webp";